module.exports = __webpack_public_path__ + "static/media/Eyes_green.5e6f1bd3.svg";